define("powergen/app",
  ["resolver","powergen/router","powergen/helpers/helpers","powergen/models/manager","powergen/models/utilities"],
  function(Resolver, router, helpers, Manager, Utilities) {
    "use strict";
    var App, injectorInit;

    Modernizr.cssprefixed = function(str) {
      return this.prefixed(str).replace(/([A-Z])/g, function(str, m1) {
        return '-' + m1.toLowerCase();
      }).replace(/^ms-/, '-ms-');
    };

    Ember.Application.initializer({
      name: 'postStoreInitializer',
      after: 'store',
      initialize: function(container, application) {
        return application.inject('transform', 'store', 'store:main');
      }
    });

    App = Ember.Application.create({
      modulePrefix: 'powergen',
      Resolver: Resolver,
      Router: Ember.Router.extend({
        router: router
      })
    });

    /*
    The following is a work around because component injectors (commented out) don't seem to work
      application.register 'utilities:main', Utilities, { singleton: true }
      application.inject 'component', 'util', 'utilities:main'
    */


    injectorInit = function() {
      this._super();
      return this.setProperties({
        'manager': Manager,
        'util': Utilities
      });
    };

    ['ObjectController', 'Route', 'View', 'Component'].forEach(function(item) {
      return Ember[item].reopen({
        init: injectorInit
      });
    });

    ['Model'].forEach(function(item) {
      return DS[item].reopen({
        init: injectorInit
      });
    });

    Ember.onLoad('Ember.Handlebars', function(h) {
      return Ember.LinkView.reopen({
        eventName: 'touchStart'
      });
    });

    App.Serializer = DS.RESTSerializer.extend();

    App.Store = DS.Store.extend();


    return App;
  });